/* eslint-disable object-curly-newline */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';

import {
  MenuItem,
  InputLabel,
  FormControl,
  ListSubheader,
} from '@material-ui/core';
import MuiSelect from '@material-ui/core/Select';

import { useStyles } from './styles';

/**
 * # Select input #
 */

const Select = ({ label, options, ...params }) => {
  const classes = useStyles();

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
    >
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        {...params}
        label={label}
      >
        {
          options.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
            >
              {option.label}
            </MenuItem>
          ))
        }
      </MuiSelect>
    </FormControl>
  );
};

Select.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
};

/**
 * # Group Select input #
 */

export const GroupSelect = ({ label, groupA, groupB, ...params }) => {
  const classes = useStyles();
  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
    >
      <InputLabel htmlFor="grouped-select">
        {label}
      </InputLabel>
      <MuiSelect
        {...params}
        label={label}
        id="grouped-select"
      >
        {groupA.options.length && (<ListSubheader>{groupA.label}</ListSubheader>)}
        {
          groupA.options.length && (
            groupA.options.map((option) => (
              <MenuItem
                key={option.value}
                value={option.value}
              >
                {option.label}
              </MenuItem>
            ))
          )
        }
        {groupB.options.length && (<ListSubheader>{groupB.label}</ListSubheader>)}
        {
          groupB.options.length && (
            groupB.options.map((option) => (
              <MenuItem
                key={option.value}
                value={option.value}
                disabled
              >
                {option.label}
              </MenuItem>
            ))
          )
        }
      </MuiSelect>
    </FormControl>
  );
};

GroupSelect.propTypes = {
  label: PropTypes.string.isRequired,
  groupA: PropTypes.object.isRequired,
  groupB: PropTypes.object.isRequired,
};

export default Select;
